<template>
  <div id="parent-workshops">
    <b-container>
      <div id="workshop-form">
        <b-row class="mt-4">
          <b-col v-if="isAdmin || isSRC" cols="4">
            <h4 class="subtitle">Add a Parent Workshop</h4>
            <b-form-group class="m-4">
              <label for="workshop_date">Date</label>
              <b-form-input
                name="workshop_date"
                type="date"
                id="date"
                v-model="dateForm"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group class="m-4">
              <div id="selected-parents">
                <label for="selected-parents">Parents in Attendance:</label>
                <b-table
                  v-cloak
                  responsive
                  :fields="parentAttendanceFields"
                  :items="parentNames"
                  :striped="true"
                  :bordered="true"
                  :hover="true"
                  stacked="md"
                  small
                >
                  <template slot="cell(delete)" slot-scope="row">
                    <b-link
                      class="delete"
                      @click.stop="deleteParentFromWorkshop(row.item)"
                      >DEL</b-link
                    >
                  </template>
                </b-table>
              </div>
            </b-form-group>
            <b-button
              variant="primary"
              block
              class="mt-2"
              @click="addOrUpdate"
              >{{ buttonTitle }}</b-button
            >
            <b-button variant="danger" block class="mt-2" @click="clearForm()"
              >Cancel</b-button
            >
          </b-col>
          <b-col v-if="isAdmin || isSRC">
            <h4 class="subtitle">
              Teacher's Current Parents ({{ parents.length || 0 }})
            </h4>
            <br />
            <br />
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div id="alerts" ref="parents-alert">
              <b-alert
                :show="dismissCountDown"
                dismissible
                variant="success"
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged"
                >You have successfully added a parent workshop!</b-alert
              >
              <b-alert :show="showError" dismissible variant="warning">
                Something went wrong. Please refresh and try again, or contact
                the site admin.
              </b-alert>
            </div>
            <b-table
              v-cloak
              responsive
              :fields="parentFields"
              :items="cleanedResults"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(student_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditStudent',
                    params: { id: row.item.student_id },
                  }"
                  >{{ row.item.student_name }}</b-link
                >
              </template>
              <template slot="cell(parent_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditParent',
                    params: { id: row.item.parent_id },
                  }"
                  >{{ row.item.parent_name }}</b-link
                >
              </template>
              <template slot="cell(add)" slot-scope="row">
                <b-link class="add" @click.stop="addParentToWorkshop(row)"
                  >ADD</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-center">
          <h4 class="text-center">Teacher's Parent Workshops</h4>
        </b-row>
        <b-row>
          <b-table
            v-cloak
            responsive
            :fields="workshopFields"
            :items="workshops"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            small
          >
            <template slot="cell(edit)" slot-scope="row">
              <b-link
                v-if="isAdmin || isSRC"
                class="edit"
                @click.stop="editWorkshop(row)"
                >EDIT</b-link
              >
            </template>
            <template slot="cell(delete)" slot-scope="row">
              <b-link
                v-if="isAdmin || isSRC"
                class="delete"
                @click.stop="deleteParentWorkshop(row.item.id)"
                >DELETE</b-link
              >
            </template>
          </b-table>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TeacherService from "@/services/TeacherService";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";

export default {
  name: "ParentWorkshops",
  mixins: [flash, scrollTo],
  data() {
    return {
      workshopId: null,
      dateForm: null,
      parentsForm: [],
      parentNames: [],
      parentIds: [],
      workshopFields: [
        { key: "date", label: "Date", sortable: true },
        { key: "parents_names", label: "Parents Names", sortable: true },
        { key: "edit", label: "EDIT" },
        { key: "delete", label: "DEL" },
      ],
      parentAttendanceFields: [
        { key: "parent_name", label: "Parents", sortable: true },
        { key: "delete", label: "DEL" },
      ],
      parentFields: [
        { key: "parent_name", label: "Parent Name", sortable: true },
        { key: "student_name", label: "Guardian of", sortable: true },
        { key: "relation", label: "Relation", sortable: true },
        { key: "add", label: "ADD" },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50],
      filter: null,
      totalRows: this.rows,
      buttonTitle: "Add Parent Workshop",
    };
  },
  methods: {
    ...mapActions({
      GET_TEACHER_PARENTS: "teachers/GET_TEACHER_PARENTS",
      GET_TEACHER_PARENT_WORKSHOPS: "teachers/GET_TEACHER_PARENT_WORKSHOPS",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
    clearForm() {
      this.dateForm = null;
      this.parentNames = [];
      this.parentIds = [];
    },
    addParentToWorkshop(props) {
      if (this.parentIds.includes(props.item.parent_uuid)) return;
      this.parentNames.push({
        parent_name: props.item.parent_name,
        parent_uuid: props.item.parent_uuid,
      });
      this.parentIds.push(props.item.parent_uuid);
    },
    async addParentWorkshop() {
      if (!this.parentIds.length || this.dateForm === null) return;
      const payload = {
        teacher_uuid: this.$route.params.id,
        parents_uuid: this.parentIds,
        workshop_date: this.dateForm,
      };
      await TeacherService.addTeacherParentWorkshop(payload);
      await this.flashSuccess();
      await this.clearForm();
      await this.GET_TEACHER_PARENT_WORKSHOPS();
    },
    async deleteParentFromWorkshop(params) {
      this.parentNames.splice(this.parentNames.indexOf(params), 1);
      this.parentIds.splice(this.parentIds.indexOf(params), 1);
    },
    async deleteParentWorkshop(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this parent workshop record?"
      );
      if (confirmDelete) {
        await TeacherService.deleteTeacherParentWorkshop(params);
        await this.GET_TEACHER_PARENT_WORKSHOPS();
      }
    },
    addOrUpdate() {
      if (this.buttonTitle === "Add Parent Workshop") {
        this.addParentWorkshop();
      } else {
        this.updateParentWorkshop();
      }
    },
    async updateParentWorkshop() {
      if (!this.parentIds.length || this.dateForm === null) return;

      const payload = {
        id: this.workshopId,
        teacher_uuid: this.$route.params.id,
        parents_uuid: this.parentIds,
        workshop_date: this.dateForm,
      };
      await TeacherService.updateTeacherParentWorkshop(payload);
      await this.flashSuccess();
      await this.clearForm();
      await this.GET_TEACHER_PARENT_WORKSHOPS();
      this.buttonTitle = "Add Parent Workshop";
    },
    editWorkshop(row) {
      this.buttonTitle = "Edit Parent Workshop";
      const new_arr = [];
      const parents_arr = row.item.parents_array;
      const parents_ids = row.item.parents_id;

      for (let i = 0; i < parents_arr.length; i++) {
        new_arr.push({
          parent_name: parents_arr[i],
          parent_uuid: parents_uuids[i],
        });
      }
      this.dateForm = row.item.date;
      this.parentNames = new_arr;
      this.parentIds = row.item.parents_uuid;
      this.workshopId = row.item.id;
    },
    deleteWorkshop() {},
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    parents: {
      get() {
        return this.$store.state.teachers.teacherParents;
      },
    },
    workshops: {
      get() {
        return this.$store.state.teachers.parentWorkshops;
      },
    },
    rows() {
      if (this.parents.length > 0) {
        return this.parents.length;
      }
    },
    cleanedResults() {
      const data = this.parents.map((k) => ({
        parent_uuid: k.parent_uuid,
        student_uuid: k.student_uuid,
        parent_name:
          k.parent_middle_name === null
            ? `${k.parent_first_name} ${k.parent_last_name}`
            : `${k.parent_first_name} ${k.parent_middle_name} ${k.parent_last_name}`,
        student_name:
          k.student_middle_name === null
            ? `${k.student_first_name} ${k.student_last_name}`
            : `${k.student_first_name} ${k.student_middle_name} ${k.student_last_name}`,
        relation: k.relation,
      }));
      return data;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.parentFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_TEACHER_PARENTS();
    this.GET_TEACHER_PARENT_WORKSHOPS();
  },
};
</script>
